import { ArrowRight, Check } from 'lucide-react';
import { BotaoLink } from '../../componentes/ui';
import { CabecalhoSecao } from './CabecalhoSecao';
import base from './publico.module.css';
import css from './Secoes.module.css';

/** Uma chamada real da API, para o desenvolvedor ver o tamanho do esforço. */
const EXEMPLO = `curl https://baixaxml.com.br/api/nfe/consulta/3524…7892 \\
  -H "x-api-key: bxk_SUA_CHAVE"

{
  "chave": "3524…7892",
  "xml": "<nfeProc versao=\\"4.00\\">…</nfeProc>",
  "cobradoCentavos": 6
}`;

/**
 * API para quem integra o BAIXA XML num sistema (ERP, contábil) ou revende.
 * O detalhe fica em `/desenvolvedores`; aqui só o suficiente para saber que
 * existe e o que dá para fazer.
 */
export function ParaDesenvolvedores({ logado }: { logado: boolean }) {
  return (
    <section id="api" className={`${base.secao} ${base.secaoSuave}`}>
      <div className={`${base.conteudo} ${css.captura}`}>
        <div className={css.capturaTexto}>
          <CabecalhoSecao
            sobretitulo="API para desenvolvedores"
            titulo="Integre ao seu sistema — ou revenda"
            className={css.capturaCabecalho}
          >
            Tudo o que o painel faz, por API: consulte uma chave e receba o XML
            na resposta, mande lotes de milhares de chaves e seja avisado por
            webhook quando terminar. Para ERPs, sistemas contábeis e quem
            oferece XML de NF-e aos próprios clientes.
          </CabecalhoSecao>

          <ul className={css.checklist}>
            <li>
              <Check aria-hidden="true" />
              <span>
                O mesmo preço do painel, por XML entregue. A faixa conta o
                volume dos últimos 30 dias — consultar uma chave por vez não sai
                mais caro.
              </span>
            </li>
            <li>
              <Check aria-hidden="true" />
              <span>
                Chave não encontrada não é cobrada, e a mesma chave repetida em
                24 horas sai de graça.
              </span>
            </li>
            <li>
              <Check aria-hidden="true" />
              <span>
                Webhooks assinados, leitura incremental das notas da captura e
                especificação OpenAPI para gerar o cliente.
              </span>
            </li>
          </ul>

          <div className={css.capturaAcoes}>
            <BotaoLink
              to="/desenvolvedores"
              data-clique="api-landing"
              aparencia="destaque"
              grande
              iconeDireita={<ArrowRight />}
            >
              Ver a documentação
            </BotaoLink>
            <BotaoLink
              to={logado ? '/painel/configuracoes' : '/criar-conta'}
              data-clique="api-chave-landing"
              aparencia="secundario"
              grande
            >
              {logado ? 'Gerar chave de API' : 'Criar conta grátis'}
            </BotaoLink>
          </div>
        </div>

        <figure
          className={css.codigoApi}
          aria-label="Exemplo de chamada da API"
        >
          <figcaption>Consulta por chave</figcaption>
          <pre>
            <code>{EXEMPLO}</code>
          </pre>
        </figure>
      </div>
    </section>
  );
}
